import * as React from 'react';
import { createElement } from 'react';
import { Input } from '@alifd/next';
import wrapper from './next-wrapper';
import { InputProps } from '@alifd/next/types/input';

export type BLProFormInputProps = InputProps;


const BLProFormInput = wrapper<BLProFormInputProps>(Input, 'BLProFormInput');
const BLProFormInputTextArea = wrapper<BLProFormInputProps>(Input.TextArea, 'BLProFormInputTextArea');
const BLProFormInputPassWord = wrapper<BLProFormInputProps>(Input.Password, 'BLProFormInputPassWord');

export {
    BLProFormInputPassWord,
    BLProFormInputTextArea
}
export default BLProFormInput;

